import {
  Component,
  OnInit,
  OnDestroy
} from "@angular/core";
import { NavigationMenuService, LoggingService, LoaderService } from "src/app/services";
import { Subscription } from "rxjs";

@Component({
    selector: 'medpt-terms-conditions',
    templateUrl: './terms-conditions.component.html',
    styleUrls: ['./terms-conditions.component.scss'],
    standalone: false
})
export class TermsConditionsComponent implements OnInit {
  linkContent: string = '<div class="sm-loading text-center"></div>';
  constructor(
    private navigationMenuService: NavigationMenuService,
    private loaderService: LoaderService) {
    this.navigationMenuService.getTerms().then((data) => {
      this.linkContent = data;
    }).finally(() => {
      this.loaderService.hideLoader();
    });;
  }

  ngOnInit(): void { }

}
